import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import HomeScreen from '../screens/HomeScreen';
import ConcertDetailScreen from '../screens/ConcertDetailScreen';
import NewsDetailScreen from '../screens/NewsDetailScreen';
import ArtistsScreen from '../screens/ArtistsScreen';
const Stack = createStackNavigator();

export default function MainNavigator() {
  return (
    <Stack.Navigator
      // initialRouteName="Home"
      // to show only artists page, initialRouteName is set to be "Artists"
      initialRouteName="Artists"
      screenOptions={{
        headerStyle: {
          // backgroundColor: '#f4511e',
          backgroundColor: 'white',
        },
        // headerTintColor: '#fff',
        headerTintColor: 'black',
        headerTitleStyle: {
          // fontWeight: 'bold',
          fontFamily: 'MPLUS1p_400Regular',
        },
      }}
    >
      <Stack.Screen
        name="Home"
        component={HomeScreen}
        options={{ title: '江戸川演奏家協会2123' }}
      />
      <Stack.Screen
        name="ConcertDetail"
        component={ConcertDetailScreen}
        options={{ title: 'コンサート詳細' }}
      />
      <Stack.Screen name="NewsDetail" component={NewsDetailScreen} />
      <Stack.Screen
        name="Artists"
        component={ArtistsScreen}
        options={{ title: '演奏家' }}
      />
    </Stack.Navigator>
    // <View>
    //   <Text>main navigator</Text>
    // </View>
  );
}
